module.exports = __webpack_public_path__ + "static/media/biglietti-background.94d5b4b2.jpg";